import { useCallback, useEffect, useState } from 'react';
import { h5ManualActivityApi } from '../../../api/h5-manual-activity';
import { PromotionGuideData } from './types';

export function useDashboardModel() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<PromotionGuideData>({ overview: null });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const response = await h5ManualActivityApi.getOverview();
      setData({ overview: response.data.data });
    } catch {
      setData({ overview: null });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return {
    loading,
    data,
    refresh: load,
  };
}
